'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _auditsbymonth = require('./auditsbymonth.component');

var _auditsbymonth2 = _interopRequireDefault(_auditsbymonth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditsbymonthModule = _angular2.default.module('auditsbymonth', [_angularUiRouter2.default]).component('auditsbymonth', _auditsbymonth2.default);

exports.default = auditsbymonthModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditsbymonth/auditsbymonth.js